import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { IoMdArrowDropdown } from 'react-icons/io';
import './Navbar.scss';
import Logo from '../../assets/images/sjmp logo.png';
import Marquee from '../Marquee/Marquee';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <div className="notice-bar">
        <span className="top-news-title"> Notice: </span>
        <Marquee />
      </div>

      <header className="navbar">
        <div className="navbar-header">
          <div className="title-search">
            <h1 className="Title-english">S.J.M (GOVT. AIDED) POLYTECHNIC</h1>
          </div>
          <img
            src={Logo}
            alt="SJM Polytechnic Logo"
            className="college-logo2"
          />
          <div className="title-search">
            <h1 className="Title-kannada">ಎಸ್.ಜೆ.ಎಮ್ (ಸರ್ಕಾರಿ ಅನುದಾನಿತ) ಪಾಲಿಟೆಕ್ನಿಕ್</h1>
          </div>
        </div>
        <div className="college-address">
          <p>(Recognised by AICTE, New Delhi)</p>
          <p>
            Ward No.1, Halepete Road, Birur, Kadur Taluk, Chikkamagaluru
            District-577116
          </p>
        </div>

        <nav className="nav-menu">
          <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FiX /> : <FiMenu />}
          </div>
          <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={closeMenu}
              >
                Home
              </NavLink>
            </li>
            <li className="dropdown">
              <NavLink
                to="/about"
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={closeMenu}
              >
                About Us
              </NavLink>
              <ul className="dropdown-menu">
                <li>
                  <NavLink
                    to="/about/desk"
                    className={({ isActive }) => (isActive ? 'active' : '')}
                    onClick={closeMenu}
                  >
                    Desk
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/about/committees"
                    className={({ isActive }) => (isActive ? 'active' : '')}
                    onClick={closeMenu}
                  >
                    Committees
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a
                href="/mandatory-disclosure.pdf"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
              >
                Mandatory Disclosure
              </a>
            </li>
            <li>
              <NavLink
                to="/affiliation"
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={closeMenu}
              >
                Affiliation
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admission"
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={closeMenu}
              >
                Admission
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/nss"
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={closeMenu}
              >
                NSS
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={closeMenu}
              >
                Contact
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/alumni"
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={closeMenu}
              >
                Alumni
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/grievance"
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={closeMenu}
              >
                Grievance
              </NavLink>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
